import WaveSurfer from 'wavesurfer.js'
import { icon, library } from '@fortawesome/fontawesome-svg-core'
import { faPlay, faPause, faVolumeHigh } from '@fortawesome/free-solid-svg-icons'

library.add(faPlay, faPause, faVolumeHigh)

function formatTime(seconds) {
  const mins = Math.floor(seconds / 60)
  const secs = Math.floor(seconds % 60)
  return `${mins}:${secs.toString().padStart(2, '0')}`
}

function setIcon(btn, faIcon) {
  btn.innerHTML = icon(faIcon).html[0]
}

export class PlayerLundis {
  /**
   * @param {Object} options
   * @param {HTMLElement} options.wrapper - le wrapper du block (pour retirer 'loading')
   * @param {HTMLElement} options.container - conteneur WaveSurfer
   * @param {HTMLElement} options.playBtn - bouton play/pause
   * @param {HTMLElement} options.currentTimeEl - élément affichant le temps courant
   * @param {HTMLElement} options.durationEl - élément affichant la durée
   * @param {string} options.audioUrl - URL du fichier audio
   */
  constructor(options) {
    this.isReady = false
    this.playerWrapper = options.wrapper || null
    this.container = options.container || null
    this.playBtn = options.playBtn || null
    this.currentTimeEl = options.currentTimeEl || null
    this.durationEl = options.durationEl || null
    this.audioUrl = options.audioUrl || null

    if (!this.container || !this.playBtn || !this.currentTimeEl || !this.durationEl || !this.audioUrl) {
      console.warn('PlayerLundis: missing required elements')
      return
    }

    this.init()
  }

  init() {
    this.waveform = WaveSurfer.create({
      container: this.container,
      waveColor: '#ccc',
      progressColor: '#FFD130',
      height: 125,
      cursorWidth: 1,
      autoScroll: true,
    })

    this.waveform.load(this.audioUrl)

    // Icône initiale
    setIcon(this.playBtn, faPlay)

    // Duration et suppression du loading
    this.waveform.on('ready', () => {
      this.isReady = true
      this.durationEl.textContent = formatTime(this.waveform.getDuration())
      if (this.playerWrapper) {
        this.playerWrapper.classList.remove('loading')
      }
    })

    // Play/Pause
    this.playBtn.addEventListener('click', () => {
      this.waveform.playPause()
      setIcon(this.playBtn, this.waveform.isPlaying() ? faPause : faPlay)
    })

    // Mettre à jour le temps courant
    const updateTime = () => {
      this.currentTimeEl.textContent = formatTime(this.waveform.getCurrentTime())
    }
    this.waveform.on('audioprocess', updateTime)
    this.waveform.on('interaction', updateTime)

    // Resize → redraw
    this.resizeHandler = () => this.waveform.setOptions({})
    window.addEventListener('resize', this.resizeHandler)
  }

  destroy() {
    try {
      if (this.waveform) {
        this.waveform.destroy()
        window.removeEventListener('resize', this.resizeHandler)
      }
    } catch (e) {
      console.warn('PlayerLundis destroy error', e)
    }
  }
}
